/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause_circle_fill': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10zm8-4a1 1 0 011 1v6a1 1 0 11-2 0V7a1 1 0 011-1zm5 1a1 1 0 10-2 0v6a1 1 0 102 0V7z" _fill="#243143" fill-opacity=".6"/>'
  }
})
